@if (showButton) {
  <button
    mat-fab
    extended
    class="feedback-fab"
    (click)="openModal()"
    [matTooltip]="'modals.feedback-report.button-tooltip' | translate"
  >
    {{ 'modals.feedback-report.button-label' | translate }}
  </button>
}
